import { PaymentMethodType } from '@nemuru-eng/js-api-client';

import { useCheckoutSessionContext } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/contexts/CheckoutSessionContext';
import { LoanPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/entities/PaymentMethodDetail/LoanPaymentMethodDetailEntity';

export const useAutoLoanPaymentMethodDetailEntity = (): LoanPaymentMethodDetailEntity | undefined =>
  useCheckoutSessionContext().paymentMethodDetailEntities.find(
    (paymentMethodDetailEntity): paymentMethodDetailEntity is LoanPaymentMethodDetailEntity =>
      paymentMethodDetailEntity.type === PaymentMethodType.AUTO_LOAN,
  );
